import { IContent } from 'models/content.model';

export const content: IContent = {
  nl: {
    pageTitle: 'ESPN',
    placeholderTitle: 'ESPN',
    eligibilityError: {
      title: 'ESPN is niet beschikbaar',
      text: 'Je hebt een actief digitaal tv-abonnement nodig en je contract mag niet meer in de minimale looptijd zitten.',
    },
    start: {
      title: 'Wij willen dat je weer gaat juichen',
      alert: {
        title: 'Let op!',
        text: 'We zijn druk bezig met het maken van een persoonlijk voorstel voor jou. Helaas kunnen we je op dit moment nog geen aanbod doen. Probeer het later nog eens.',
      },
      content: `
        Fijn dat jij met ons deelt wat je wel en niet wilt. 
        Je gaat vanaf 1 juli €2,50 meer betalen voor je tv-pakket. Én we hebben ESPN 2, 3 en 4 toegevoegd aan het standaard zenderpakket. Maar dan moet je natuurlijk wel van voetbal houden 😉. 
        <br/><br/>
        Dat je hier bent, betekent dat je niet blij bent met de wijziging. We houden je graag verbonden met wat jij wél belangrijk en leuk vindt om te zien. 
        Daarom kijken we samen jou graag naar een oplossing die bij jou past. Klik op start en volg de instructies om jouw voorkeuren door te geven. Op basis van je antwoorden, krijg je een persoonlijk voorstel.
      `,
      b2bContent: `
        Fijn dat jij met ons deelt wat je wel en niet wilt. 
        Je gaat vanaf 1 juli €2,00 meer betalen voor je tv-pakket. Én we hebben ESPN 2, 3 en 4 toegevoegd aan het standaard zenderpakket. Maar dan moet je natuurlijk wel van voetbal houden 😉. 
        <br/><br/>
        Dat je hier bent, betekent dat je niet blij bent met de wijziging. We houden je graag verbonden met wat jij wél belangrijk en leuk vindt om te zien. 
        Daarom kijken we samen jou graag naar een oplossing die bij jou past. Klik op start en volg de instructies om jouw voorkeuren door te geven. Op basis van je antwoorden, krijg je een persoonlijk voorstel.
      `,
      buttonText: 'Start',
    },
    streamerZapper: {
      title: 'Ben jij een streamer of een zapper?',
      content:
        'Om je het beste aanbod te kunnen doen, willen we weten wat jij het liefste kijkt. Stream je graag een lekkere serie of film? Of zit je liever zappend op de bank tv te kijken?',
      buttonText: 'Doe mij een aanbod',
      offerOptions: {
        streamer: 'Ik ben een streamer',
        zapper: 'Ik ben een zapper',
        altijdAlles: 'Verras me maar!',
      },
    },
  },
  en: {},
};
